import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-confirm-swap",
  templateUrl: "./confirm-swap.page.html",
  styleUrls: ["./confirm-swap.page.scss"],
})
export class ConfirmSwapPage implements OnInit {
  transactionPassword: string;
  selectedPair: any;
  fromWallet: any;
  from_address: string;
  toWallet: any;
  from_asset_amount: any;
  to_asset_amount: any;

  activeView: string = "send";
  transactionInfo: any;

  passInputConfig = {
    length: 4,
    inputClass: "otp-input-item",
    containerClass: "otp-input-holder",
    inputStyles: {
      width: "35px",
      height: "35px",
    },
    allowNumbersOnly: true,
  };

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.selectedPair = this.navParams.get("selectedPair");
    this.fromWallet = this.navParams.get("fromWallet");
    this.from_address = this.navParams.get("from_address");
    this.toWallet = this.navParams.get("toWallet");
    this.from_asset_amount = this.navParams.get("from_asset_amount");
    this.to_asset_amount = this.navParams.get("to_asset_amount");
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  txnPasswordChanged(event: any) {
    this.transactionPassword = event;
  }

  async submit() {
    if (
      this.transactionPassword !== undefined &&
      this.transactionPassword.length == 4
    ) {
      let data = {
        pair_id: this.selectedPair.pair_id,
        from_wallet_id: this.fromWallet.wallet_id,
        to_wallet_id: this.toWallet.wallet_id,
        value: this.to_asset_amount,
        txn_password: this.transactionPassword,
      };

      this.alertandLoading.presentLoading("sending transaction please wait");

      this.api.swapAsset(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            this.transactionInfo = result.data.transaction;
            this.activeView = "result";
          } else {
            this.alertandLoading.showAlert(
              "Alert",
              "Oops something went wront try again"
            );
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          console.log(error);
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Alert",
        "Please enter a valid 4 digit transaction password"
      );
    }
  }
}
